import {
  REMOVE_LISTING_START,
  REMOVE_LISTING_SUCCESS,
  REMOVE_LISTING_ERROR
} from '../constants';
import history from '../core/history';
import showToaster from '../helpers/showToaster';
import { reservationCount, RemoveListing as mutation } from '../lib/graphql';
import { userRestriction } from '../helpers/DemoRestriction/demoRestriction';

export function removeListing(listId, userRole) {

  return async (dispatch, getState, { client }) => {
    try {

      const isRestrict = await dispatch(userRestriction({ restrictType: 'listing', restrictValue: listId }));
      if (isRestrict) {
        showToaster({ messageId: 'demoWarning', toasterType: 'warning' });
        return;
      }

      dispatch({
        type: REMOVE_LISTING_START,
      });

      let upcomingBookingCount;
      const bookedData = await client.query({
        query: reservationCount,
        variables: {
          listId
        },
        fetchPolicy: 'network-only'
      });

      if (bookedData?.data?.getUpcomingBookings) {
        upcomingBookingCount = bookedData.data.getUpcomingBookings.count;
      }

      if (upcomingBookingCount > 0) {
        showToaster({ messageId: 'upcomingBooking', toasterType: 'error' })
        dispatch({
          type: REMOVE_LISTING_ERROR,
        });
      }
      else {
        // Send Request to get listing data
        const { data } = await client.mutate({
          mutation,
          variables: { listId },
        });

        if (data?.RemoveListing) {
          dispatch({
            type: REMOVE_LISTING_SUCCESS,
          });
          if (userRole != undefined && userRole === "admin") {
            history.push('/siteadmin/listings/');
          } else {
            history.push('/rooms');
          }

          if (data?.RemoveListing?.length > 0) {
            const removeFiles = await fetch('/removeMultiFiles', {
              method: 'post',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({
                files: data.RemoveListing,
              }),
              credentials: 'include',
            });
          }
        } else {
          dispatch({
            type: REMOVE_LISTING_ERROR,
          });
        }
      }
    } catch (error) {
      const errorText = [error?.message, ...(error?.graphQLErrors || []).map((e) => e?.message)].join(' ');
      if (errorText.includes('LISTING_HAS_THREADS')) {
        showToaster({ messageId: 'listingHasThreads', toasterType: 'error' });
      } else if (errorText.includes('LISTING_HAS_UPCOMING_BOOKINGS')) {
        showToaster({ messageId: 'upcomingBooking', toasterType: 'error' });
      } else if (errorText.includes('LISTING_HAS_RESERVATIONS')) {
        showToaster({ messageId: 'listingHasReservations', toasterType: 'error' });
      }
      dispatch({
        type: REMOVE_LISTING_ERROR,
        payload: {
          error
        }
      });
      return false;
    }

    return true;
  };
}
